export default {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setReportName(state, reportName) {
    state.reportName = reportName;
  },
  setReports(state, reports = []) {
    state.reports = reports.map(report => ({
      ...report,
      pathName: 'report-performance',
      icon: 'chart-line',
      image: '/static/images/logo-intelipost.png',
    }));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/bi-reports/store/mutations.js